import type { ComponentProps } from 'react';
import { Input } from '@/shared/ui/input';
import { cn } from '@/shared/lib/cn';

interface MaskedInputProps extends Omit<ComponentProps<typeof Input>, 'onChange' | 'value'> {
  value: string;
  onValueChange: (value: string) => void;
  mask: (value: string) => string;
}

/** Input controlado com função de máscara aplicada no onChange. */
export function MaskedInput({ value, onValueChange, mask, className, ...props }: MaskedInputProps) {
  return (
    <Input
      {...props}
      className={cn(className)}
      value={value}
      onChange={(e) => onValueChange(mask(e.target.value))}
    />
  );
}
